import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, onMounted, onUnmounted, computed } from 'vue'
import { getActivityList } from '@/api/offers';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { checkDate, formatUnixTimestamp, getNextDayDate } from '@/utils/commonFunction';
import OffersView from '@/themes/themeOne/offers/offersView.vue';
import OffersViewTwo from '@/themes/themeTwo/offers/offersView.vue';
import OffersViewThree from '@/themes/themeThree/offers/offersView.vue';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'offersView',
  setup(__props) {

const themeStore = useThemeStore()
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()

const isActivityEnableTime = ref(false)
const activityList = ref([])
const startTime = ref(0)
const endTime = ref(0)
const claimedDate = ref('')
const days = ref(0)
const hours = ref(0)
const minutes = ref(0)
const seconds = ref(0)
const floatImage = ref("")
let timer: number
const activityIntro = ref([])

const dataSet = computed(() => ({
    isActivityEnableTime: isActivityEnableTime.value,
    activityList: activityList.value,
    startTime: startTime.value,
    endTime: endTime.value,
    claimedDate: claimedDate.value,
    days: days.value,
    hours: hours.value,
    minutes: minutes.value,
    seconds: seconds.value,
    floatImage: floatImage.value,
    activityIntro: activityIntro.value
}))

const setCountdownTarget = (dateStr: string) => {
    // Parse the input date and set target time to 23:59:59
    const target = new Date(`${dateStr}T23:59:59`)
    return target.getTime()
}

const startCountdown = (dateStr: string) => {
    endTime.value = setCountdownTarget(dateStr)
    updateCountdown()
    setInterval(updateCountdown, 1000) // update every second
}

const updateCountdown = () => {
    const now = new Date()
    const diff = endTime.value - now.getTime()

    if (diff <= 0) {
        days.value = hours.value = minutes.value = seconds.value = 0
        return
    }

    const totalSeconds = Math.floor(diff / 1000)
    days.value = Math.floor(totalSeconds / (3600 * 24))
    hours.value = Math.floor((totalSeconds % (3600 * 24)) / 3600)
    minutes.value = Math.floor((totalSeconds % 3600) / 60)
    seconds.value = totalSeconds % 60

}
const getDayNameFromTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", { weekday: "long" });
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getOfferActivityList = () => {
    loadingRef.value.open()
    getActivityList().then(res => {
        loadingRef.value.close()
        let data = res.data.activity_data
        let activityConfig = JSON.parse(data.activityConfig)
        activityList.value = activityConfig.reward_config
        activityIntro.value = JSON.parse(data.activityIntro)
        let extraConfig = JSON.parse(data?.activityExtra)
        startTime.value = data.startTime
        claimedDate.value = getNextDayDate(extraConfig?.week_day || 0) // 0-mon 1-teu 2-wed 3-thur 4-fri 5-sat 6-sun
        startCountdown(claimedDate.value)
        if (checkDate(claimedDate.value) === 0) {
            isActivityEnableTime.value = true
        } else {
            isActivityEnableTime.value = false
        }

        floatImage.value = data.floatIcon
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

onMounted(() => {

    timer = setInterval(updateCountdown, 1000)
    getOfferActivityList()
})

onUnmounted(() => {
    clearInterval(timer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(OffersView, { "data-set": dataSet.value }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(OffersViewTwo, { "data-set": dataSet.value }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(OffersViewThree, { "data-set": dataSet.value }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})